import { useState } from 'react'
import { Container } from './style'
import { CardInput } from '../../../../inputMasks'

export function InputCard({ 
    value, 
    onChange, 
    placeholder, 
    mask, 
    img, 
    empty, 
    cardType = '', 
    setCardFocused, 
    maxLength 
}) {
    const [isFocused, setIsFocused] = useState(false)

    function handleFocus() {
        setIsFocused(true)
        setCardFocused(cardType)
    }

    function handleBur() {
        setIsFocused(false)
    }


    return (
        <Container 
            isFocused={isFocused}
            onFocus={handleFocus}
            onBlur={handleBur}
            empty={empty}
            fullInput={img !== undefined}
        >
            <CardInput 
                placeholder={placeholder}
                value={value} 
                onChange={event => onChange(event.target.value)}
                mask={mask}
                maxLength={maxLength}
            />
            {img !== undefined ?
                <img 
                    src={img} 
                    alt='icon'
                />
            :<></>}
        </Container>
    )
}
